import React from "react";

/**
 * Mihrab-style arched frame. If `src` is provided, renders an image;
 * otherwise renders a labeled placeholder box with gold arch border.
 */
export const MihrabFrame = ({ src, alt, label, className = "", aspect = "aspect-[3/4]", backdrop }) => {
  return (
    <div className={`mihrab-frame ${aspect} relative ${className}`}>
      {src ? (
        <>
          {backdrop && (
            <img
              src={backdrop}
              alt=""
              aria-hidden="true"
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover"
            />
          )}
          <img
            src={src}
            alt={alt || "Hazrat Shahanshah Sufi Sarkar"}
            loading="lazy"
            className={`relative h-full w-full ${backdrop ? "object-contain" : "object-cover"}`}
          />
        </>
      ) : (
        <div className="h-full w-full flex flex-col items-center justify-center bg-ivory-alt text-center px-6">
          <span className="font-serif text-2xl text-emerald" data-testid="mihrab-placeholder-label">
            {label || "Portrait Placeholder"}
          </span>
          <span className="mt-2 text-xs uppercase tracking-[0.3em] text-gold">awaiting authentic photo</span>
        </div>
      )}
    </div>
  );
};

export default MihrabFrame;
